/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureSummary } from './CaptureSummary';
import {
    CaptureSummaryFromJSON,
    CaptureSummaryFromJSONTyped,
    CaptureSummaryToJSON,
    CaptureSummaryToJSONTyped,
} from './CaptureSummary';

/**
 * 
 * @export
 * @interface SetCaptureLabelResponse
 */
export interface SetCaptureLabelResponse {
    /**
     * 
     */
    captures: Array<CaptureSummary>;
}

/**
 * Check if a given object implements the SetCaptureLabelResponse interface.
 */
export function instanceOfSetCaptureLabelResponse(value: object): value is SetCaptureLabelResponse {
    if (!('captures' in value) || value['captures'] === undefined) return false;
    return true;
}

export function SetCaptureLabelResponseFromJSON(json: any): SetCaptureLabelResponse {
    return SetCaptureLabelResponseFromJSONTyped(json, false);
}

export function SetCaptureLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCaptureLabelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'captures': ((json['captures'] as Array<any>).map(CaptureSummaryFromJSON)),
    };
}

export function SetCaptureLabelResponseToJSON(json: any): SetCaptureLabelResponse {
    return SetCaptureLabelResponseToJSONTyped(json, false);
}

export function SetCaptureLabelResponseToJSONTyped(value?: SetCaptureLabelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'captures': ((value['captures'] as Array<any>).map(CaptureSummaryToJSON)),
    };
}

